import OrdersDetails from "@ca/orderDetails/pages/OrderDetails";
import { IRoute } from "@src/routes";

const routes: IRoute[] = [
  {
    path: "/ca/orderDetails/:id",
    key: "DETALHE_PEDIDO",
    component: OrdersDetails,
  },
];

export default routes;